export const GENERATE_PROMOCODE_REQUEST = "GENERATE_PROMOCODE_REQUEST";
export const GENERATE_PROMOCODE_SUCCESS = "GENERATE_PROMOCODE_SUCCESS";
export const GENERATE_PROMOCODE_FAILURE = "GENERATE_PROMOCODE_FAILURE";
export const GENERATE_PROMOCODE_CLEAN = "GENERATE_PROMOCODE_CLEAN";